<template>
    <gz-auth-view-template :bc="false" contentClass="gz-auth-view-template__content_inner">

        <section slot="filters" class="gz-filters">         
            <GZ-DateInput 
                @dateValue="filters.beginDate = $event" 
                :value="filters.beginDate"
                class="gz-date-input_no-border gz-date-input_calend-schedule"
                placeholder="с"
            />
            <GZ-DateInput 
                @dateValue="filters.endDate = $event" 
                :value="filters.endDate"
                class="gz-date-input_no-border gz-date-input_calend-schedule"
                placeholder="по"
            />
            
            <GZ-TextInput 
                class="gz-input-container_200px"
                style="margin-right: 2px"
                @value="filters.city = $event"
                :importedData="filters.city"
                placeholder="Населенный пункт"
            />
            <GZ-TextInput 
                class="gz-input-container_200px"
                style="margin-right: 2px"
                @value="filters.street = $event"
                :importedData="filters.street"
                placeholder="Улица"
            />
            
            <GZ-BaseButton 
                value="показать" 
                class="gz-button_default gz-button_default_filter"
                :class="{'gz-button_disabled': !canFilter}"
                @click="canFilter ? getSchedule() : false"
            />
            <!-- <GZ-BaseButton 
                value="сбросить" 
                class="gz-button_default gz-button_default_filter gz-button_monohrome"
                :class="{'gz-button_disabled': !canFilter}"
                @click="resetFilters()"
            /> -->
        </section>

        <section slot="content" class="gz-title-cols-row">
            <!-- Cols titles -->
            <GZ-TableDataRow :title="true">                
                <GZ-TableDataCol slot="cols" class="gz-data__col_title gz-data__col_50px">
                    <!-- № -->
                    <div class="gz-col-inner">
                        <span>№</span>
                    </div>
                </GZ-TableDataCol>
                <GZ-TableDataCol slot="cols" class="gz-data__col_title gz-data__col_200px">
                    <!-- Населенный пункт -->
                    <div class="gz-col-inner">
                        <span>Населенный пункт</span>
                    </div>
                </GZ-TableDataCol>
                <GZ-TableDataCol slot="cols" class="gz-data__col_title gz-data__col_200px">
                    <!-- Адрес -->
                    <div class="gz-col-inner">
                        <span>Адрес</span>
                    </div>
                </GZ-TableDataCol>
                <GZ-TableDataCol slot="cols" class="gz-data__col_title gz-data__col_100px">
                    <!-- Дом -->
                    <div class="gz-col-inner">
                        <span>Дом</span>
                    </div>
                </GZ-TableDataCol>
                <GZ-TableDataCol slot="cols" class="gz-data__col_title gz-data__col_100px">
                    <!-- Помещений -->
                    <div class="gz-col-inner">
                        <span title="Помещений">Пом.</span>
                    </div>
                </GZ-TableDataCol>
                <GZ-TableDataCol slot="cols" class="gz-data__col_title gz-data__col_100px">
                    <!-- Этажность -->
                    <div class="gz-col-inner">
                        <span title="Этажность">Эт.</span>
                    </div>
                </GZ-TableDataCol>
                <GZ-TableDataCol slot="cols" class="gz-data__col_title gz-data__col_100">
                    <!-- Календарь -->
                    <div class="gz-col-inner">
                        <div class="gz-checkups__calendar">
                            <div 
                                class="gz-checkups__calendar__item gz-checkups__calendar__item_title"
                                v-for="(item, index) in month"
                                :key="index"
                            >{{ item }}</div>
                        </div>
                    </div>
                </GZ-TableDataCol>
            </GZ-TableDataRow>
        </section>

        <section slot="content">
            <ScheduleRow 
                v-for="(item, index) in checkups" 
                :key="index"
                :item="item"
                :index="index+1"
            />
        </section>      
    </gz-auth-view-template>
</template>

<script>
import ScheduleRow from '@/components/custom/admin/views/checkups/BaseCheckupScheduleRow'

export default {
    name: 'AdminCheckupsSchedule',

    components: {
        ScheduleRow
    },
    data() {
        return {
            filters: {
                beginDate: '',
                endDate: '',
                city: '',
                street: '',
            },
            checkups: [],
            canFilter: true,
            month: [
                'Янв.',
                'Фев.',
                'Март',
                'Апр.',
                'Май',
                'Июнь',
                'Июль',
                'Авг.',
                'Сен.',
                'Окт.',
                'Ноя.',
                'Дек.'
            ]
        }
    },
    computed: {
        canFilterComputed() {
            return this.canFilter
        }
    },
    methods: {
        getSchedule() {
            this.$axios({
                method: 'GET',
                url: 'schedule',
                params: {
                    pg: 0, 
                    batch: 100,
                    beginDate: this.filters.beginDate ? this.filters.beginDate.toISOString().split('.')[0] : '',
                    endDate: this.filters.endDate ? this.filters.endDate.toISOString().split('.')[0] : '',
                    city: this.filters.city,
                    street: this.filters.street
                }
            })
            .then(({data}) => {
                this.checkups = data.data
            })
            .catch(err => {
                console.error('Ошибка получения списка проверок: ', err)
            })
        },
        resetFilters() {
            this.filters.beginDate = ''
            this.filters.endDate = ''
            this.filters.city = ''
            this.filters.street = ''

            this.getSchedule()
        }
    },
    watch: {
        endDate: function(newVal) {
            const date = newVal.toISOString().slice(0, 4)
            
            if (this.filters.beginDate) {
                if (date !== this.filters.beginDate.toISOString().slice(0, 4)) {
                    this.canFilter = false
                } else { this.canFilter = true }
            }
        },
        beginDate: function(newVal) {
            const date = newVal.toISOString().slice(0, 4)

            if (this.filters.endDate) {
                if (date !== this.filters.endDate.toISOString().slice(0, 4)) {
                    this.canFilter = false
                } else { this.canFilter = true }
            }
        }
    }
}
</script>